import React from "react"
import { CircularProgress, Stack } from "@mui/material"

interface Props {
  title?: string
  size?: number
}

const Loader: React.FC<Props> = ({ size = 50 }) => (
  <Stack margin="auto" alignItems="center">
    <CircularProgress size={size} />
  </Stack>
)

export default Loader
